import(/* webpackMode: "eager" */ "/app/src/app/team/page.tsx");
